import { motion } from 'framer-motion';
import { SwiperClass } from 'swiper/react';

import { IProductPageViewModel } from 'Types/Litium';

import CaretIcon from 'Icons/caretGsd.svg?react';

const ProductSliderNavigation = ({
    translations,
    swiper,
}: {
    translations: IProductPageViewModel['translations'];
    swiper: SwiperClass;
}) => {
    const gotoPrev = () => {
        swiper.slidePrev();
    };
    const gotoNext = () => {
        swiper.slideNext();
    };

    return (
        swiper?.slides?.length > 1 && (
            <>
                <motion.button
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    initial={{ opacity: 0 }}
                    onClick={gotoPrev}
                    key="prevSlide"
                    className="absolute left-2 top-[calc(50%-32px)] z-[1] flex h-7 w-7 items-center justify-center rounded-full bg-silverLight lg:left-4 lg:top-[calc(50%-38px)] lg:h-14 lg:w-14"
                >
                    <CaretIcon className="h-2.5 w-2.5 rotate-180 lg:h-6 lg:w-6" />
                    <span className="sr-only">
                        {translations.generalPreviousSlide}
                    </span>
                </motion.button>
                <motion.button
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    initial={{ opacity: 0 }}
                    key="nextSlide"
                    onClick={gotoNext}
                    className="absolute right-2 top-[calc(50%-32px)] z-[1] flex h-7 w-7 items-center justify-center rounded-full bg-silverLight lg:right-4 lg:top-[calc(50%-38px)] lg:h-14 lg:w-14"
                >
                    <CaretIcon className="h-2.5 w-2.5 rotate-0 lg:h-6 lg:w-6" />
                    <span className="sr-only">
                        {translations.generalNextSlide}
                    </span>
                </motion.button>
            </>
        )
    );
};
export default ProductSliderNavigation;
